/* global AAMSuite, siteComponents */

/**
 * Paywall Component.
 */

import { Component } from 'js-component-framework';

/**
 * Paywall Class
 */
export default class Paywall extends Component {
  static initializePaywall(selector) {
    // Add class to body for css
    document.body.classList.add('paywall-initialized');

    // Find paywall element to apply transformations
    const element = document.querySelector(selector);
    if (!element) {
      return;
    }

    element.style.display = 'block';

    // Selectors to truncate.
    const selectors = [
      '.entry-content',
      '.paywall-truncate',
    ];

    // Hydrate selectors into elements.
    selectors.reduce((acc, elSelector) => {
      const items = document.querySelectorAll(elSelector);
      return [
        ...acc,
        ...items,
      ];
    }, [])
      .forEach((el) => {
      // Remove content links from tabindex
        const links = el.querySelectorAll('a');
        Array.from(links).forEach((link) => {
          link.setAttribute('tabindex', '-1');
        });

        // Hide content from screen readers
        el.setAttribute('aria-hidden', 'true');
      });
  }

  static killPaywallEvent() {
    document.body.classList.remove('paywall-initialized');

    // Selectors to restore.
    const selectors = [
      '.entry-content',
      '.paywall-truncate',
    ];

    // Hydrate selectors into elements
    selectors.reduce((acc, elSelector) => {
      const items = document.querySelectorAll(elSelector);
      return [
        ...acc,
        ...items,
      ];
    }, [])
      .forEach((el) => {
      // Return content links from tabindex
        const links = el.querySelectorAll('a');
        Array.from(links).forEach((link) => {
          link.setAttribute('tabindex', '0');
        });

        // Restore content for screen readers
        el.setAttribute('aria-hidden', 'false');
      });
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    this.isAuthorized = false;

    if (typeof AAMSuite !== 'object') {
      return;
    }

    if (
      typeof siteComponents !== 'object'
      || typeof siteComponents.paywall === 'undefined'
      || typeof siteComponents.paywall.article_level !== 'number'
    ) {
      return;
    }

    // Get the current url and append it as the redirect url for the login button
    const loginButton = document.querySelector('.paywall-overlay .button');
    if (typeof loginButton !== 'undefined' && loginButton !== null) {
      loginButton.setAttribute('href', `/login/?redirect_to=${window.location.href}`);
    }

    AAMSuite.getMemberProfile({
      success(profile) {
        if (
          siteComponents.paywall.product_id
          && !profile.products.includes(siteComponents.paywall.product_id)
        ) {
          Paywall.initializePaywall('.paywall--type-loggedin-unauthorized');
        } else if (profile.member_level >= siteComponents.paywall.article_level) {
          // if user is equal to or higher in level than the article, don't run the paywall
          Paywall.killPaywallEvent();
        } else if (profile.member_level < siteComponents.paywall.article_level) {
          // if the user is lower level than the article level, show the unauth paywall
          Paywall.initializePaywall('.paywall--type-loggedin-unauthorized');
        } else if (siteComponents.paywall.article_level > 1) {
          // otherwise, initialize the logged out paywall by default
          Paywall.initializePaywall('.paywall--type-loggedout');
        }
      },
      error() {
        Paywall.isAuthorized = false;
        if (siteComponents.paywall.product_id || siteComponents.paywall.article_level > 1) {
          Paywall.initializePaywall('.paywall--type-loggedout');
        }
      },
    });
  }
}
